import { render, staticRenderFns } from "./AddAuditPeriod.vue?vue&type=template&id=25145788"
import script from "./AddAuditPeriod.vue?vue&type=script&lang=js"
export * from "./AddAuditPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports